import { render, staticRenderFns } from "./MemberPicker.vue?vue&type=template&id=2938f1f3&scoped=true"
import script from "./MemberPicker.vue?vue&type=script&lang=js"
export * from "./MemberPicker.vue?vue&type=script&lang=js"
import style0 from "./MemberPicker.vue?vue&type=style&index=0&id=2938f1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938f1f3",
  null
  
)

export default component.exports